class LWOverlay extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
    }

    static get observedAttributes() {
        return ['open', 'bg-color'];
    }

connectedCallback() {
    this.render();
    this.sync();

    if (this.parentElement && this.parentElement !== document.body) {
        document.body.appendChild(this);
    }
}

    attributeChangedCallback() {
        this.render();
        this.sync();
    }

    sync() {
        const open = this.hasAttribute('open');
        this.inert = !open;
        this.setAttribute('role', 'dialog');
        this.setAttribute('aria-modal', open ? 'true' : 'false');
        this.setAttribute('aria-hidden', open ? 'false' : 'true');
    }

    render() {
        const isOpen = this.hasAttribute('open');
        const bgColor = this.getAttribute('bg-color') || 'rgba(0,0,0,0.95)';

        this.shadowRoot.innerHTML = /* html */ `
        <style>
            :host {
                position: fixed;
                top: 0;
                left: 0;
                width: 100vw;
                /* GEBRUIK hoogte in plaats van min-hoogte om de 'bak' te begrenzen */
                height: 100vh; 
                z-index: 9999;
                
                display: block;

                /* Zorg dat de OVERFLOW op de host zelf zit */
                overflow-y: auto; 
                overflow-x: hidden;
                -webkit-overflow-scrolling: touch; /* Voor soepel scrollen op iPhone */

                background-color: ${bgColor};
                transition: transform 0.4s cubic-bezier(0.77, 0, 0.175, 1);
                
                /* Gebruik -100% voor een betere transformatie */
                transform: translateY(${isOpen ? '0' : '-100%'});
                pointer-events: ${isOpen ? 'auto' : 'none'};
                visibility: ${isOpen ? 'visible' : 'hidden'};
            }

            @media (prefers-reduced-motion: reduce) {
                :host {
                    transition: none;
                }
            }

            .container {
                width: 100%;
                max-width: var(--lw-container-width, 800px);
                padding: 40px 40px 120px 40px;
                box-sizing: border-box;
                min-height: 101%;
            }

            @media (max-width: 767px) {
                .container {
                    padding: 60px 30px 100px 25px;
                }
            }

            ::slotted(*) {
                /* Zorgt dat alles in de slot goed meedoet */
                display: block;
            }

            ::slotted(a) {
                display: block;
                font-size: 40px;
                font-weight: 900;
                color: white;
                text-decoration: none;
                margin-bottom: 20px;
            }
        </style>

        <div class="container">
            <slot></slot>
        </div>
        `;
    }
}

customElements.define('lw-overlay', LWOverlay);